import {
  ELanguage,
} from '@qmulus/frontend-shared/type/locale.ts';
import {
  AxiosResponse,
} from 'axios';
import {
  KeycloakProfile,
} from 'keycloak-js';
import {
  defineStore,
} from 'pinia';

import fakeData from './fake-data.json';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import {
  TGetAppGroupsResponse,
  getAppGroups,
} from '@/generated/qmulus/axios/price-calculator.ts';
import {
  asyncRequestActionList,
} from '@/store/pinia/request.ts';
import {
  IPriceCalculatorSettings,
} from '@/types/price-calculator-type.ts';
import {
  getDefaultLanguage,
} from '@/utils/language-util.ts';

export const useAppStore = defineStore('app', {
  state: () => ({
    groupList: undefined as TGetAppGroupsResponse | undefined,
    groupListPromise: undefined as Promise<AxiosResponse> | undefined,
    customerList: undefined as any[] | undefined,
    user: undefined as KeycloakProfile | undefined,
    userPromise: undefined as Promise<KeycloakProfile | undefined> | undefined,
    groups: undefined as any[] | undefined,
    settings: undefined as IPriceCalculatorSettings | undefined,
  }),
  getters: {
    locale(): ELanguage {
      return getDefaultLanguage();
    },
  },
  actions: {
    async loadCurrentUser() {
      if (this.userPromise) {
        return this.userPromise;
      }

      const promise = keycloakAuthenticationHandler.getUserProfile();
      this.userPromise = promise;

      try {
        this.user = await promise;
      } finally {
        this.userPromise = undefined;
      }

      return this.user;
    },
    async loadGroups() {
      return asyncRequestActionList({
        callback: () => getAppGroups(),
        list: this.groupList,
        promise: this.groupListPromise,
        setList: (data) => {
          this.groupList = data;
        },
        setPromise: (promise) => {
          this.groupListPromise = promise;
        },
      });
    },
    loadSettings() {
      const settings: IPriceCalculatorSettings = fakeData.settings;
      this.settings = settings;
    },
  },
});
